/**
 * Shared Tailwind class sets for the redesign, copied from the approved prototype
 * (docs/design-reference/homepage-prototype.html: .btn, .btn.ghost, .btn.sm, .ibtn, .tlink).
 */
/** Keyboard focus only (prototype :focus-visible): 3px green outline, 2px offset. */
export const focusRing =
  'focus:outline-none focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-primary';

export const btnBase = `inline-flex items-center justify-center gap-2 rounded-full font-ui font-semibold transition-colors ${focusRing} disabled:opacity-50 disabled:cursor-not-allowed`;

/** Green pill, 15px, 44px tall. */
export const btnPrimary = `${btnBase} min-h-[44px] px-[22px] py-[11px] text-[15px] bg-primary text-white hover:bg-primary-dark`;

/** White pill with a line border. */
export const btnGhost = `${btnBase} min-h-[44px] px-[22px] py-[11px] text-[15px] bg-white text-ink border-[1.5px] border-line hover:border-primary hover:text-primary-dark`;

/** Small variants (14px, 38px tall). */
export const btnPrimarySm = `${btnBase} min-h-[38px] px-4 py-2 text-sm bg-primary text-white hover:bg-primary-dark`;
export const btnGhostSm = `${btnBase} min-h-[38px] px-4 py-2 text-sm bg-white text-ink border-[1.5px] border-line hover:border-primary hover:text-primary-dark`;

/** Round icon button (share, favorite, close). */
export const iconBtn = `grid place-items-center rounded-full p-1.5 min-w-[38px] min-h-[38px] text-mute hover:bg-warm-white hover:text-ink transition-colors ${focusRing}`;

/** Green text link with an arrow, 14.5px. */
export const textLink =
  'inline-flex items-center gap-1.5 whitespace-nowrap font-ui text-[14.5px] font-semibold text-primary hover:text-primary-dark hover:underline underline-offset-[3px]';
